import { Modal, Button } from 'react-bootstrap';

export default function Confirm({ showModal, setShowModal, message, onConfirm, onClose }) {
    const handleCloseModal = () => {
        setShowModal(false);
        onClose && onClose();

    };

    const handleConfirm = () => {
        setShowModal(false);
        onConfirm && onConfirm();
        //handleCloseModal();
    };

    return (
        <>
            <Modal show={showModal} onHide={handleCloseModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{ __html: message }}></div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleConfirm}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};